import { render, staticRenderFns } from "./SyncAccountManagerWidget.vue?vue&type=template&id=53a71d8b"
import script from "./SyncAccountManagerWidget.vue?vue&type=script&lang=js"
export * from "./SyncAccountManagerWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports